export default "__VITE_ASSET__0dd1f0b3__"